// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { useEffect } from 'react';
import { useFindDatasetById } from '../../state/hooks/DatasetHooks';
import { useCurrentScenarioData } from '../../state/hooks/ScenarioHooks';
import {
  useAddTechVar,
  useGetAgingLawsByScenario,
  useGetAgingLawsTwingraphQueriesResults,
  useGetTechVar,
  useTwingraphQueriesStatus,
} from '../../state/wizard/WizardHooks';

export const useEquipementWizardHook = () => {
  const scenarioData = useCurrentScenarioData();
  const scenarioId = scenarioData.id;
  const datasetId = scenarioData.datasetList[0];
  const findDatasetById = useFindDatasetById();
  const datasetData = findDatasetById(datasetId);
  const doesDatasetExist = !!datasetData;
  const isDatasetTwingraph = datasetData?.ingestionStatus !== null;
  const datasetIngestionStatus = datasetData?.ingestionStatus;

  const getTwingraphQueriesResults = useGetAgingLawsTwingraphQueriesResults(scenarioData);
  const status = useTwingraphQueriesStatus();
  const addTechVar = useAddTechVar();
  const familleEquipement = useGetTechVar('familleEquipement', scenarioId);

  useEffect(() => {
    getTwingraphQueriesResults(datasetId);
  }, [datasetId, getTwingraphQueriesResults, scenarioData]);

  const agingLaws = useGetAgingLawsByScenario(scenarioId);

  return {
    status,
    agingLaws,
    addTechVar,
    familleEquipement,
    scenarioId,
    datasetId,
    doesDatasetExist,
    isDatasetTwingraph,
    datasetIngestionStatus,
  };
};
